<template>
  <div class="w-full">
    <div class="flex items-center justify-center">
      <button
          type="button"
          class="relative h-32 w-32 rounded-md overflow-hidden border border-gray-300"
          :class="disabled ? 'opacity-60 pointer-events-none' : 'cursor-pointer'"
          @click="openModal"
          :title="value ? 'مشاهده / تغییر تصویر' : 'انتخاب تصویر'"
      >
        <img v-if="currentPreview" :src="currentPreview" class="h-full w-full object-cover" alt=""/>

        <div
            v-else
            class="h-full w-full border-2 border-dashed border-gray-300 flex items-center justify-center"
        >
          <div class="text-center text-[11px] text-white">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="mx-auto my-auto h-6 w-6 mb-1 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6H16a4 4 0 010 8h-1m-4 4v-8m0 0l-3 3m3-3l3 3"/>
            </svg>
            <span>آپلود تصویر</span>
          </div>
        </div>

        <!-- Remove quick button -->
        <button
            v-if="value"
            type="button"
            class="col-span-2 px-3 py-2 rounded-lg text-xs font-bold border border-rose-500/30 bg-rose-500/10 hover:bg-rose-500/15 transition
       flex items-center justify-center text-center text-rose-200"
            @click.stop="clear"
            :disabled="disabled"
        >
          حذف
        </button>
      </button>
    </div>

    <div ref="portalRoot" class="sim-portal-root" v-show="isOpen">
      <transition name="sim-fade">
        <div v-if="isOpen" class="sim-overlay" @keydown.esc="closeModal" tabindex="-1">
          <!-- Backdrop -->
          <div class="sim-backdrop" @click="closeModal"></div>

          <!-- Centered modal -->
          <div class="sim-modal">
            <!-- Header -->
            <div class="sim-header">
              <div class="text-sm font-bold text-slate-100">تصویر محصول</div>
              <button
                  type="button"
                  class="px-2 py-1 rounded-lg text-slate-200 hover:bg-white/10"
                  @click="closeModal"
              >
                ✕
              </button>
            </div>

            <!-- Preview -->
            <div class="p-4">
              <div
                  class="w-full aspect-square rounded-lg overflow-hidden border border-white/10 bg-slate-950/40 flex items-center justify-center">
                <img v-if="currentPreview" :src="currentPreview" class="w-full h-full object-cover" alt=""/>
                <div v-else class="text-xs text-slate-400 text-center px-4">
                  هنوز تصویری انتخاب نشده
                </div>
              </div>

              <p v-if="error" class="mt-3 text-xs text-rose-300">{{ error }}</p>

              <div class="mt-4 grid grid-cols-2 gap-2">
                <button
                    type="button"
                    class="px-3 py-2 rounded-lg text-xs font-bold border border-white/10 bg-white/5 hover:bg-white/10 transition flex items-center justify-center text-center"
                    @click="openCamera"
                    :disabled="disabled"
                >
  <span class="text-slate-100 text-center">
    {{ cameraActive ? '📷 دوربین فعال است' : '📷 دوربین' }}
  </span>
                </button>
                <button
                    type="button"
                    class="px-3 py-2 rounded-lg text-xs font-bold border border-white/10 bg-white/5 hover:bg-white/10 transition flex items-center justify-center text-center"
                    @click="openPicker"
                    :disabled="disabled"
                >
                  <span class="text-slate-100 text-center"> 🖼️ گالری / فایل</span>


                </button>

                <button
                    v-if="value"
                    type="button"
                    class="col-span-2 px-3 py-2 rounded-lg text-xs font-bold border border-rose-500/30 bg-rose-500/10 hover:bg-rose-500/15 transition flex items-center justify-center text-center text-rose-200"
                    @click="clear"
                    :disabled="disabled"
                >
                  <span class="text-slate-100 text-center"> حذف تصویر</span>


                </button>

                <button
                    type="button"
                    class="col-span-2 px-3 py-2 rounded-lg text-xs font-bold border border-white/10 bg-white/5 hover:bg-white/10 transition
       flex items-center justify-center text-center text-slate-200"
                    @click="closeModal"
                >
                  <span class="text-slate-100 text-center"> {{value? 'انتخاب':'بستن'}}</span>


                </button>
              </div>

              <p v-if="hint" class="mt-3 text-[11px] text-slate-400">{{ hint }}</p>
            </div>

            <!-- Camera panel (desktop/webcam) -->
            <div v-if="cameraActive" class="mt-4">
              <div
                  class="w-full aspect-square rounded-lg overflow-hidden border border-white/10 bg-black flex items-center justify-center">
                <video
                    ref="video"
                    autoplay
                    playsinline
                    muted
                    class="w-full h-full object-cover"
                ></video>
              </div>

              <div class="mt-3 grid grid-cols-2 gap-2">
                <button
                    type="button"
                    class="px-3 py-2 rounded-lg text-xs font-bold border border-white/10 bg-white/5 hover:bg-white/10 transition flex items-center justify-center text-center"
                    @click="capturePhoto"
                    :disabled="disabled || cameraBusy"
                >
                  <span class="text-slate-100">📸 گرفتن عکس</span>
                </button>

                <button
                    type="button"
                    class="px-3 py-2 rounded-lg text-xs font-bold border border-white/10 bg-white/5 hover:bg-white/10 transition flex items-center justify-center text-center"
                    @click="stopCamera"
                    :disabled="cameraBusy"
                >
                  <span class="text-slate-100">⛔ بستن دوربین</span>
                </button>
              </div>

              <canvas ref="canvas" class="hidden"></canvas>
            </div>
            <input
                ref="cameraInput"
                type="file"
                class="hidden"
                accept="image/*"
                capture="environment"
                @change="onFileChange"
            />
            <input
                ref="pickerInput"
                type="file"
                class="hidden"
                :accept="accept"
                @change="onFileChange"
            />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "SmartImagePickerModal",
  props: {
    value: {type: Object, default: null},
    disabled: {type: Boolean, default: false},
    hint: {type: String, default: ""},
    maxSizeMB: {type: Number, default: 10},
    accept: {type: String, default: "image/*"},

    // pass resolved preview url if image is string from server
    currentPreviewUrl: {type: String, default: ""},
  },
  data() {
    return {

      isOpen: false,
      error: "",
      _localPreview: "",
      _mountedToBody: false,
      _originalParent: null,
      _nextSibling: null,

      cameraActive: false,
      cameraBusy: false,
      _stream: null,

    };
  },
  computed: {
    currentPreview() {
      if (this.currentPreviewUrl) return this.currentPreviewUrl;
      if (this.value && this.value.preview) return this.value.preview;
      return this._localPreview || "";
    },
  },
  mounted() {
    // Prepare portal root for body
    this.mountPortalToBody();
  },
  beforeDestroy() {
    this.stopCamera();
    this.unmountPortal();
    this.unlockBodyScroll();
  },
  methods: {

    isMobileLike() {
      // تشخیص ساده؛ مهم: دسکتاپ capture رو جدی نمی‌گیره
      return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    },

    async openCamera() {
      this.error = "";

      // موبایل‌ها: همون input capture بهترینه
      if (this.isMobileLike()) {
        if (this.$refs.cameraInput) {
          this.$refs.cameraInput.value = null;
          this.$refs.cameraInput.click();
          return;
        }
      }

      // دسکتاپ: WebRTC
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.error = "این مرورگر از دوربین پشتیبانی نمی‌کند. از گالری/فایل استفاده کن.";
        // fallback
        this.openPicker();
        return;
      }

      this.cameraBusy = true;

      try {
        // اگر قبلاً استریم داشتیم، ببند
        await this.stopCamera();

        const constraints = {
          video: {
            facingMode: "environment", // ممکنه روی لپ‌تاپ نادیده گرفته بشه
          },
          audio: false,
        };

        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        this._stream = stream;
        this.cameraActive = true;

        await this.$nextTick();
        const video = this.$refs.video;
        if (video) {
          video.srcObject = stream;
          // بعضی مرورگرها نیاز به play دستی دارن
          const p = video.play && video.play();
          if (p && p.catch) p.catch(() => {
          });
        }
      } catch (err) {
        // Permission denied / no device / https requirement
        const msg = (err && err.name) ? err.name : "";
        if (msg === "NotAllowedError" || msg === "PermissionDeniedError") {
          this.error = "اجازه‌ی دسترسی به دوربین داده نشد. از تنظیمات مرورگر اجازه بده.";
        } else if (msg === "NotFoundError" || msg === "DevicesNotFoundError") {
          this.error = "هیچ دوربینی پیدا نشد.";
        } else if (msg === "NotReadableError") {
          this.error = "دوربین توسط برنامه‌ی دیگری در حال استفاده است.";
        } else {
          this.error = "باز کردن دوربین ناموفق بود. از گالری/فایل استفاده کن.";
        }

        // fallback به file picker
        this.openPicker();
      } finally {
        this.cameraBusy = false;
      }
    },

    async stopCamera() {
      // stop tracks
      if (this._stream) {
        try {
          this._stream.getTracks().forEach((t) => t.stop());
        } catch (e) {
        }
      }
      this._stream = null;
      this.cameraActive = false;

      // پاک کردن video srcObject
      const video = this.$refs.video;
      if (video && video.srcObject) {
        try {
          video.srcObject = null;
        } catch (e) {
        }
      }
    },

    capturePhoto() {
      this.error = "";
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      if (!video || !canvas) return;

      const w = video.videoWidth || 0;
      const h = video.videoHeight || 0;

      if (!w || !h) {
        this.error = "تصویر دوربین آماده نیست. یک لحظه بعد دوباره بزن.";
        return;
      }

      canvas.width = w;
      canvas.height = h;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, w, h);

      // کیفیت و حجم: jpeg
      canvas.toBlob(
          (blob) => {
            if (!blob) {
              this.error = "گرفتن عکس ناموفق بود.";
              return;
            }

            const maxBytes = this.maxSizeMB * 1024 * 1024;
            if (blob.size > maxBytes) {
              this.error = `حجم تصویر زیاد است. (حداکثر ${this.maxSizeMB}MB)`;
              return;
            }

            const file = new File([blob], `camera_${Date.now()}.jpg`, {type: blob.type || "image/jpeg"});
            const preview = URL.createObjectURL(blob);

            const payload = {file, preview};
            this.$emit("input", payload);
            this.$emit("change", payload);
            this._localPreview = preview;

            // دوربین رو ببند (یا اگر می‌خوای باز بمونه حذف کن)
            this.stopCamera();
          },
          "image/jpeg",
          0.92
      );
    },

    mountPortalToBody() {
      const el = this.$refs.portalRoot;
      if (!el || this._mountedToBody) return;

      this._originalParent = el.parentNode;
      this._nextSibling = el.nextSibling;

      document.body.appendChild(el);
      this._mountedToBody = true;
    },

    unmountPortal() {
      const el = this.$refs.portalRoot;
      if (!el || !this._mountedToBody) return;

      try {
        if (this._originalParent) {
          if (this._nextSibling) this._originalParent.insertBefore(el, this._nextSibling);
          else this._originalParent.appendChild(el);
        }
      } catch (e) {
        // ignore
      }
      this._mountedToBody = false;
      this._originalParent = null;
      this._nextSibling = null;
    },

    lockBodyScroll() {
      document.documentElement.classList.add("sim-modal-lock");
      document.body.classList.add("sim-modal-lock");
    },
    unlockBodyScroll() {
      document.documentElement.classList.remove("sim-modal-lock");
      document.body.classList.remove("sim-modal-lock");
    },

    openModal() {
      this.error = "";
      this.isOpen = true;
      this.lockBodyScroll();
      this.$nextTick(() => {
        // focus overlay to catch ESC
        const root = this.$el.querySelector(".sim-overlay");
        if (root) root.focus();
      });
    },
    closeModal() {
      this.isOpen = false;
      this.error = "";
      this.stopCamera();
      this.unlockBodyScroll();
    },
    openPicker() {
      this.error = "";
      if (this.$refs.pickerInput) {
        this.$refs.pickerInput.value = null;
        this.$refs.pickerInput.click();
      }
    },

    onFileChange(e) {
      this.error = "";
      const file = (e.target && e.target.files && e.target.files[0]) || null;
      if (!file) return;

      if (!file.type || !file.type.startsWith("image/")) {
        this.error = "فایل تصویر معتبر نیست.";
        return;
      }

      const maxBytes = this.maxSizeMB * 1024 * 1024;
      if (file.size > maxBytes) {
        this.error = `حجم تصویر زیاد است. (حداکثر ${this.maxSizeMB}MB)`;
        return;
      }

      const reader = new FileReader();
      reader.onload = (ev) => {
        const payload = {file, preview: ev.target.result};
        this.$emit("input", payload);
        this.$emit("change", payload);
        this._localPreview = payload.preview;
      };
      reader.readAsDataURL(file);
    },

    clear() {
      this.error = "";
      this.$emit("input", null);
      this.$emit("change", null);
      this._localPreview = "";
      this.closeModal();
    },
  },
};
</script>

<style scoped>
/* portal root should not affect layout */
.sim-portal-root {
  position: fixed;
  inset: 0;
  z-index: 999999;
}
/* overlay full screen */
.sim-overlay {
  position: fixed;
  inset: 0;
  z-index: 999999;
  pointer-events: auto;
  outline: none;
}

.sim-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .72);
}

/* overlay full screen */
.sim-overlay {
  position: fixed;
  inset: 0;
  z-index: 999999;
  pointer-events: auto;
  outline: none;

  /* ✅ مرکز واقعی */
  display: grid;
  place-items: center;

  /* ✅ padding برای اینکه روی اسکرین‌های کوچیک به لبه نچسبه */
  padding: 16px;

  /* ✅ ارتفاع صحیح در موبایل‌ها/سرفیس‌ها */
  min-height: 100vh;
  min-height: 100 dvh;
}

.sim-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .72);
}

/* ✅ modal روی backdrop بالاتر */
.sim-modal {
  position: relative;
  width: 100%;
  max-width: 28rem;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, .10);
  background: rgba(15, 23, 42, .92);
  backdrop-filter: blur(16px);

  /* ✅ اگر محتوا زیاد شد از صفحه بیرون نزنه */
  max-height: calc(100dvh - 32px);
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
}

/* ✅ محتوای داخل مودال اسکرول بگیره نه اینکه مودال بیاد بیرون */
.sim-modal .p-4 {
  overflow: auto;
}

.sim-modal {
  width: 100%;
  max-width: 28rem; /* ~ max-w-md */
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, .10);
  background: rgba(15, 23, 42, .92);
  backdrop-filter: blur(16px);
}

.sim-header {
  padding: 12px 16px;
  background: rgba(30, 41, 59, .60);
  border-bottom: 1px solid rgba(255, 255, 255, .10);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* fade */
.sim-fade-enter-active, .sim-fade-leave-active {
  transition: opacity .15s ease;
}

.sim-fade-enter, .sim-fade-leave-to {
  opacity: 0;
}
</style>

<style>
.sim-modal-lock {
  overflow: hidden !important;
}
</style>